module.exports = require("./kam-KE");